export enum SceneTranscodingStates {
    invalidConditions = 'invalid_conditions',
    required = 'required',
    processing = 'processing',
    completed = 'completed',
}